
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Référencement Web : définition et guide du SEO On-Page",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez ce qu'est le SEO On-Page et comment optimiser vos pages web pour améliorer leur visibilité. Techniques et conseils pour un référencement efficace.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Référencement Web : définition du SEO On-Page",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Qu’est-ce que le SEO On-Page ? Comment optimiser le vôtre ? Cet article fait le tour des principes et astuces !",
        },
      ],
    };
  },
};
